import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
// lib
import { isValidDate, parseDate } from 'data/lib/dates.ts'
// styles
import { Checkbox_s, Dropdown_s, InputText_s } from 'styles/input-styles'
import { Label_s } from 'styles/app-styles'
import { DateText_s } from 'styles/report-styles'
// types
import { FolderReportProps, ReportFormParameters } from './reports'

type ReportType = 'folder_occupancy'
const displayName = 'Occupancy'

type Cutoff = 'Analysis Term' | 'Analysis Term + 1'
type Periodicity = 1 | 3 | 12

type OccupancyReportParameters = ReportFormParameters & {
  begindate: string // MM/DD/YYYY
  cutoff: Cutoff
  period: Periodicity
  report: ReportType
  term: number
  totals: boolean
}

const cutoffOptions = [
  { value: 'Analysis Term + 1'},
  { value: 'Analysis Term' },
]

const periodicityOptions = [
  { text: 'Annual', value: 12 },
  { text: 'Monthly', value: 1 },
  { text: 'Quarterly', value: 3 }
]

export const propertyFilter = (property) => property.type !== 'Hospitality'

export const Occupancy: FC<FolderReportProps> = (props) => {
  const [cutoff, setCutoff] = useState<Cutoff>('Analysis Term + 1')
  const [includeAnnualTotals, setIncludeAnnualTotals] = useState<boolean>(false)
  const [periodicity, setPeriodicity] = useState<Periodicity>(12)
  const [startdate, setStartDate] = useState<string>(props.reportbegindate)
  const [term, setTerm] = useState<number>(props.term)
  const [termOnce, setTermOnce] = useState<boolean>(false)

  if (!term && props.term && !termOnce) {
    setTerm(props.term)
    setTermOnce(true)
  }

  useEffect(() => {
    const valid = isValidDate(startdate) && !_.isNil(term) && term >= 3

    if (disableIncludeAnnualTotals() && includeAnnualTotals) setIncludeAnnualTotals(false)

    props.setParameters(getParameters())
    props.setValid(valid)
  }, [includeAnnualTotals, periodicity, startdate, term, cutoff])

  function getParameters(): OccupancyReportParameters {
    return {
      begindate: startdate,
      cutoff,
      period: periodicity,
      report: 'folder_occupancy',
      term: +term,
      totals: includeAnnualTotals
    }
  }

  function disableIncludeAnnualTotals() {
    return periodicity == 12
  }

  return (
    <>
      <div>
        <Label_s>Start Date</Label_s>
        <DateText_s
          value={parseDate(startdate).format('MM/DD/YYYY')}
          onChange={setStartDate}
          onBlur={setStartDate}
          persist={setStartDate}
          withoutDays
        />
      </div>
      <div>
        <Label_s>Term</Label_s>
        <InputText_s
          keyfilter="pnum"
          onChange={(e) => setTerm(e.target.value)}
          value={term}
        />
      </div>
      <div>
        <Label_s>Periodicity</Label_s>
        <Dropdown_s
          onChange={(e) => setPeriodicity(e.value)}
          optionLabel="text"
          options={periodicityOptions}
          value={periodicity}
        />
      </div>
      <div>
        <Label_s>Display Annual Totals?</Label_s>
        <Checkbox_s
          checked={includeAnnualTotals}
          disabled={disableIncludeAnnualTotals()}
          onChange={(e) => setIncludeAnnualTotals(e.checked)}
        />
      </div>
      <div>
        <Label_s>Property Cutoff Date</Label_s>
        <Dropdown_s
          onChange={(e) => setCutoff(e.value)}
          optionLabel="value"
          options={cutoffOptions}
          value={cutoff}
        />
      </div>
    </>
  )
}

Occupancy.displayName = displayName
export default Occupancy
